/* RetroParlour – bannerslider. De balk in de actieve tab loopt op tijd; als die vol is gaat de volgende banner open. */
class RpBanners extends HTMLElement {
  connectedCallback() {
    this.slides = [...this.querySelectorAll('.rp-bn__slide')];
    this.tabs = [...this.querySelectorAll('.rp-bn__tab')];
    this.pauseBtn = this.querySelector('.rp-bn__pause');
    this.index = 0;
    this.held = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.syncPause();

    this.tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => this.show(i));
      tab.querySelector('.rp-bn__bar').addEventListener('animationend', () => {
        if (i === this.index) this.show((i + 1) % this.slides.length);
      });
    });

    this.pauseBtn.addEventListener('click', () => {
      this.held = !this.held;
      this.syncPause();
    });

    const hover = (on) => this.classList.toggle('is-hovered', on);
    if (window.matchMedia('(hover: hover)').matches) {
      this.addEventListener('mouseenter', () => hover(true));
      this.addEventListener('mouseleave', () => hover(false));
    }
    this.addEventListener('focusin', (e) => {
      if (e.target.matches(':focus-visible')) this.classList.add('is-focused');
    });
    this.addEventListener('focusout', () => this.classList.remove('is-focused'));

    let startX = null;
    const stage = this.querySelector('.rp-bn__stage');
    stage.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', (e) => {
      if (startX === null) return;
      const dx = e.changedTouches[0].clientX - startX;
      startX = null;
      if (Math.abs(dx) < 40) return;
      const n = this.slides.length;
      this.show((this.index + (dx < 0 ? 1 : -1) + n) % n);
    }, { passive: true });

    document.addEventListener('shopify:block:select', this.onEditorSelect = (e) => {
      const i = this.slides.findIndex((s) => s === e.target);
      if (i < 0) return;
      this.held = true;
      this.syncPause();
      this.show(i);
    });
  }

  disconnectedCallback() {
    document.removeEventListener('shopify:block:select', this.onEditorSelect);
  }

  show(i) {
    this.index = i;
    this.slides.forEach((slide, n) => {
      slide.classList.toggle('is-active', n === i);
      slide.inert = n !== i;
    });
    this.tabs.forEach((tab, n) => {
      tab.classList.toggle('is-active', n === i);
      if (n === i) tab.setAttribute('aria-current', 'true');
      else tab.removeAttribute('aria-current');
    });
  }

  syncPause() {
    this.classList.toggle('is-held', this.held);
    this.pauseBtn.setAttribute('aria-pressed', String(this.held));
    this.pauseBtn.setAttribute('aria-label', this.held ? 'Play banners' : 'Pause banners');
  }
}

if (!customElements.get('rp-banners')) customElements.define('rp-banners', RpBanners);
